import { Component, Injector, OnInit, Input } from '@angular/core';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import {
  ChangeUserLanguageDto,
  ProfileServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'font-size-changer',
  templateUrl: './font-size-changer.component.html',
})
export class FontSizeChangerComponent
  extends ThemesLayoutBaseComponent
  implements OnInit {
  languages: abp.localization.ILanguageInfo[];
  currentLanguage: abp.localization.ILanguageInfo;

  @Input() isDropup = false;
  @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean btn-lg mr-1';

  public constructor(
    injector: Injector,
    private _profileServiceProxy: ProfileServiceProxy
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.languages =  this.localization.languages?.filter(
      (l) => l.isDisabled === false
    );
    this.currentLanguage = this.localization.currentLanguage;
  }

  htmlFontSizeSet(size: number) {
    document.getElementsByTagName(
      'html'
    )[0].style.cssText = `font-size: ${size}px !important`;
  }
}
